import React from 'react'
import ModalYesNo from './ModalYesNo'

export default function RevokeAccreditationModal() {
  return (
    <ModalYesNo>
      Отозвать аккредитацию?
    </ModalYesNo>
  )
}